<div class="container-fluid">
  <app-group-action-selector 
    header="Group Restore"  
    [typeOptions]="dropdownOption"
    (filterApplied)="handleFilters($event)" 
    (showTable)="handlereset()">
  </app-group-action-selector>

  <div class="row justify-content-center" *ngIf="!showtable">
    <img src="assets/DashboardIcon/applyfilters.svg" alt="" height="300px" width="400px">
  </div>

  <div *ngIf="showtable">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <button [disabled]="DISABLEBTN" class="btn btn-success" (click)="getcheckboxitems()">Restore</button>
    </div>
    <div class="row">
      <app-table [pageNation]="false" [paginationPageSizeSelector]="[10,20,50]"></app-table>
    </div>
  </div>
  <div class="groupactoinresult">
    <groupaction-result typeaction="Restore" [Show]="showResult" [result]="bulkResult"></groupaction-result>
  </div>
</div>
